/* @flow */

import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { compose, withState, mapProps } from 'recompose';

// import cx from 'classnames';

// import classes from './HoverTooltip.scss';

type PropsType = {
  children: any,
  hideTip: Function,
  id: string,
  showTip: Function,
  showTooltip: boolean,
  text: any,
  title: any,
  toggle: Function,
};

export class HoverTooltip extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    children: <div />,
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    return (
      <span className="d-flex ml-auto">
        { /* nested span needed to center tool tip over the children */ }
        <span>
          <div
            id={`popover-${this.props.id}`}
            onMouseEnter={this.props.showTip}
            onMouseLeave={this.props.hideTip}
          >
            {this.props.children}
          </div>
        </span>
        <Popover
          placement="right"
          isOpen={this.props.showTooltip}
          target={`popover-${this.props.id}`}
          toggle={this.props.toggle}
        >
          <PopoverHeader>
            <strong>{this.props.title}</strong>
          </PopoverHeader>
          <PopoverBody>{this.props.text}</PopoverBody>
        </Popover>
      </span>
    );
  }
}

const enhancer = compose(
  withState('showTooltip', 'setTooltip', false),
  mapProps(
    ({ setTooltip, ...rest }: { [key: string]: any }): {} => ({
      toggle: (): boolean => setTooltip((b: boolean): boolean => !b),
      showTip: (): boolean => setTooltip(true),
      hideTip: (): boolean => setTooltip(false),
      ...rest,
    }),
  ),
);

export default enhancer(HoverTooltip);



// WEBPACK FOOTER //
// ./src/components/HoverTooltip/HoverTooltip.js